import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { Button } from "@mui/material";
import { database } from "configs/firebaseConfigs";
import { useAppContext } from "contexts";
import { ref, remove, set, update } from "firebase/database";
import { useIsMounted } from "hooks";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Swal from "sweetalert2";

const CartCard = (props) => {
  const { user } = useAppContext();
  let isMounted = useIsMounted();

  const [cartQuantity, setCartQuantity] = useState(props?.data?.cartQuantity);

  const decrease = () => {
    if (cartQuantity > 1) {
      setCartQuantity(cartQuantity - 1);
    } else {
      setCartQuantity(1);
    }
  };

  const handleRemove = async () => {
    try {
      await remove(ref(database, `cart/${user?.uid}/${props?.data?.id}`));
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Item removed from cart",
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const handleWishlist = () => {
    try {
      if (!user.uid) {
        Swal.fire({
          title: "Please login to add to wishlist",
          icon: "warning",
        });
        return;
      }
      const wishListData = {
        id: props?.data?.id,
        quantity: cartQuantity,
        createdAt: Date.now(),
      };
      set(
        ref(database, `wishlist/${user?.uid}/${props?.data?.id}`),
        wishListData
      )
        .then(() => {
          handleRemove().then(() => {
            Swal.fire({
              title: "Added to wishlist",
              icon: "success",
            });
          });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Something Went Wrong. Try Again!",
            icon: "error",
          });
        });
    } catch (error) {
      Swal.fire({
        title: "Something Went Wrong. Try Again!",
        icon: "error",
      });
    }
  };

  useEffect(() => {
    async function updateCart() {
      try {
        await update(ref(database, `cart/${user?.uid}/${props?.data?.id}`), {
          quantity: cartQuantity,
        });
      } catch (error) {
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    }
    if (isMounted.current) {
      updateCart();
    }
  }, [cartQuantity, isMounted, props?.data?.id, user?.uid]);

  return (
    <div
      className="cart-item-children flex-row gap-2 justify-content-between"
      key={props?.data?.id}
    >
      <div className="main-cart-items flex-row gap-2">
        <div className="cart-img-section flex-row align-items-center justify-content-center ">
          <img
            src={props?.data?.images[0] && props?.data?.images[0]?.url}
            alt=""
          />
        </div>
        <div className="cart-item-details-section flex-column gap-1">
          <div className="cart-item-name">
            <h3> {props?.data?.name} </h3>
          </div>
          <div className="cart-item-supplier-details flex-column gap-1">
            <span className="supplier-name flex-row align-items-center gap-1">
              Supplier : <p> {props?.data?.supplierName} </p>
            </span>
            <span className="item-quantity flex-row align-items-center gap-1">
              Quantity : <p> {props?.data?.cartQuantity} </p>
            </span>
          </div>
          <div className="cart-item-amount-details flex-row align-items-center gap-1">
            <span className="item-price flex-row align-items-center ">
              <p> SAR {props?.data?.price} </p>
            </span>
            <span className="item-discount-price flex-row align-items-center ">
              <p>
                SAR{" "}
                {(props?.data?.price *
                  (100 + parseInt(props?.data?.discount || 0))) /
                  100}{" "}
              </p>
            </span>
            <span className="item-discount-percentage flex-row align-items-center ">
              <p> {props?.data?.discount || 0}% off </p>
            </span>
          </div>
          <div className="cart-item-btn flex-row gap-2">
            <Button className="cart-item-save-btn" onClick={handleWishlist}>
              Save for later
            </Button>
            <Button className="cart-item-remove" onClick={handleRemove}>
              Remove
            </Button>
          </div>
        </div>
      </div>
      <div className="cart-item-counter flex-row justify-content-center">
        <Button onClick={decrease}>
          <RemoveCircle />
        </Button>
        <span className="counter flex-row align-items-center justify-content-center ">
          {cartQuantity}
        </span>
        <Button
          onClick={() => {
            setCartQuantity(cartQuantity + 1);
          }}
        >
          <AddCircle />
        </Button>
      </div>
    </div>
  );
};

export default CartCard;
